module.exports = __webpack_public_path__ + "static/garantiaContacto-a825443d6a35cfdc0ce30d0a00037f3d.jpg";